// Hooks/index.tsx
import { FC } from 'react'
import { AuthProvider } from './Auth'  // Certifique-se de importar do arquivo correto
import { ToastProvider } from './ToasContext'

const HooksProvider: FC<{ children: React.ReactNode }> = ({ children }) => (
  <AuthProvider>
    <ToastProvider>{children}</ToastProvider>
  </AuthProvider>
)

export { HooksProvider }
